<script setup lang="tsx">
import { h } from 'vue'

import * as Outline from '@heroicons/vue/24/outline';
import * as Solid from '@heroicons/vue/20/solid';

export type IconNames = keyof typeof Outline;

interface Props {
  name: IconNames
  class?: string
  solid: boolean
}

const props = withDefaults(defineProps<Props>(), {
  class: "h-5 w-5",
  solid: false,
});

const IconStyle = props.solid ? Solid : Outline;
const jsxNode = () => h(IconStyle[props.name], { class: props.class });

</script>
<template>
  <jsxNode />
</template>